
import screenfull from 'screenfull'
import { Component, Vue } from 'vue-property-decorator'

const sf = screenfull as any

@Component({
    name: 'Screenfull'
})
export default class extends Vue {
    private isFullscreen = false

    mounted() {
        if (sf.enabled) {
            sf.on('change', this.change)
        }
    }

    beforeDestory() {
        if (sf.enabled) {
            sf.off('change', this.change)
        }
    }

    private change() {
        if (sf.enabled) {
            this.isFullscreen = sf.isFullscreen
        }
    }

    private click() {
        if (!sf.enabled) {
            this.$message({
                message: 'you browser can not work',
                type: 'warning'
            })
            return false
        }
        sf.toggle()
    }
}
